<template>
  <v-container fluid>
    <v-row justify="space-between" align="center">
      <v-col><h5 class="text-h5">Reporte de Stock</h5></v-col>
      <v-col cols="12" md="3">
        <month-picker v-model="date" @input="fetchStockDaily"></month-picker>
      </v-col>
    </v-row>

    <v-row dense v-if="stocks && stocks.length > 0">
      <v-col cols="12" sm="12">
        <v-tabs  v-model="tabs">
          <v-tab v-for="(tab) in getTabs" :key="tab.key">
            <span>{{ tab.title }}</span>
          </v-tab>

        </v-tabs>
      </v-col>

      <v-col cols="12" sm="12">
        <v-tabs-items v-model="tabs">
          <v-tab-item v-for="stock in stocks" :key="stock.id">
            <v-simple-table>
              <thead>
              <tr>
                <th>Fecha</th>
                <th></th>
                <th v-for="item in stock.items.filter(i => i.hide === false)" :key="item.product.id">
                  {{ item.product.shortName }}
                </th>
              </tr>
              </thead>

              <tbody v-for="stockDaily in getStocksDailyByBranch(stock.branch)" :key="stockDaily.id">
              <tr>

                <td rowspan="3" style="border-bottom: 2px solid black">{{ getDateFormat(stockDaily.date) }}</td>
                <td>Stock</td>
                <td
                    v-for="item in stock.items.filter(i => i.hide === false)"
                    :key="item.product.id"
                    :class="item.minimum >=  getProductInStock(stockDaily, item.product) ? 'red--text font-weight-bold' : 'black--text'"
                >
                  {{ getProductInStock(stockDaily, item.product) }}
                </td>
              </tr>
              <tr>
                <td>Reposición</td>
                <td v-for="item in stock.items.filter(i => i.hide === false)" :key="item.product.id">
                  {{ getProductAdded(stockDaily, item.product) }}
                </td>
              </tr>
              <tr>
                <td style="border-bottom: 2px solid black">Retiro</td>
                <td v-for="item in stock.items.filter(i => i.hide === false)" :key="item.product.id"
                    style="border-bottom: 2px solid black">
                  {{ getProductRemoved(stockDaily, item.product) }}
                </td>
              </tr>

              </tbody>

            </v-simple-table>
          </v-tab-item>

          <!--TOTAL-->
          <v-tab-item key="total">
            <v-simple-table>
              <thead>
              <tr>
                <th>Fecha</th>
                <th></th>
                <th v-for="product in products" :key="product.id">
                  {{ product.shortName }}
                </th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="date in getStocksDailyDates" :key="date.toString()">
                <td>{{ getDateFormat(date) }}</td>
                <td>Stock</td>
                <td v-for="product in products" :key="product.id">
                  {{ getProductTotalInStock(date, product) }}
                </td>
              </tr>
              </tbody>

            </v-simple-table>
          </v-tab-item>

        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StockProvider from "@/modules/delivery/providers/StockProvider";
import ProductProvider from "@/modules/delivery/providers/ProductProvider";
import {Dayjs, DayjsMixin} from "@dracul/dayjs-frontend"
import StockDailyProvider from "@/modules/delivery/providers/StockDailyProvider";
import MonthPicker from "@/modules/delivery/components/MonthPicker/MonthPicker";

export default {
  name: "StockReportPage",
  components: {MonthPicker},
  mixins: [DayjsMixin],
  data() {
    return {
      loading: false,
      tabs: 0,
      products: [],
      stocks: [],
      stocksDaily: [],
      date: Dayjs().format("YYYY-MM")
    }
  },
  created() {
    this.fetchProduct()
    this.fetchStockDaily()
        .then(() => this.fetchStock())

  },
  computed: {
    getTabs() {
      let options = this.stocks.map(s => ({title: s.branch.name, key: s.id}))
      options.push({title: 'Total', id: 'total'})
      return options
    },
    getDates() {
      let dates = []
      let today = Dayjs(this.date, 'YYYY-MM')
      let endOfMonth = today.clone().add(1, 'month')
      let counter = 0
      while (endOfMonth.isAfter(today) && counter < 31) {
        dates.push(today.format('YYYY-MM-DD'))
        today = today.add(1, 'day')
        counter++
      }
      return dates
    },
    getStocksDailyByBranch() {
      return branch => {
        return this.stocksDaily.filter(s => s.branch.id === branch.id)
      }
    },
    getStocksDailyDates() {
      return this.stocksDaily.reduce((a, v) => {
        if (!a.includes(v.date)) a.push(v.date)
        return a
      }, [])
    },
    getProductAdded() {
      return (stockDaily, product) => {
        let item = stockDaily.items.find(i => i.product.id === product.id)
        return item ? item.added : 0
      }
    },
    getProductRemoved() {
      return (stockDaily, product) => {
        let item = stockDaily.items.find(i => i.product.id === product.id)
        return item ? item.removed : 0
      }
    },
    getProductInStock() {
      return (stockDaily, product) => {
        let item = stockDaily.items.find(i => i.product.id === product.id)
        return item ? item.stock : 0
      }
    },
    getProductTotalInStock() {
      return (date, product) => {
        return this.stocksDaily.filter(sd => sd.date === date).reduce((a, v) => {
          let item = v.items.find(i => i.product.id === product.id)
          return a + (item ? item.stock : 0)
        }, 0)
      }
    }
  },

  methods: {
    fetchStockDaily() {
      return new Promise((resolve) => {
        this.loading = true
        StockDailyProvider.fetchStockDailyFromDate(this.date)
            .then(r => {
              console.log("r", r.data.fetchStockDailyFromDate)
              this.stocksDaily = r.data.fetchStockDailyFromDate
            })
            .finally(() => {
              this.loading = false
              resolve()
            })
      })
    },
    fetchProduct() {
      return new Promise((resolve) => {

        this.loading = true
        ProductProvider.fetchProduct()
            .then(r => {
              this.products = r.data.fetchProduct
            })
            .finally(() => {
              this.loading = false
              resolve()
            })
      })
    },
    fetchStock() {
      return new Promise((resolve) => {
        this.loading = true
        StockProvider.fetchStock()
            .then(r => {
              this.stocks = r.data.fetchStock
              console.log("stocks", this.stocks)
            })
            .finally(() => {
              this.loading = false
              resolve()
            })
      })
    },
  }
}
</script>

<style scoped>

</style>
